import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { localData } from "../../Services/AuthHeader";
import jwt_decode from "jwt-decode";
import { useEffect } from "react";

function PublicRoute(props) {

  const gettoken = localData();
  // console.log(gettoken);

  if (gettoken) {
    return <Navigate to={'/'} replace={true} />;
  }
  return props.children;
}

export default PublicRoute;
